import { FC } from 'react';
import { formatCurrencyDecimals, formatNumberDecimals } from 'utils/formats';

import { useGetUsufructuariesTooltipText } from 'modules/partners/hooks/useGetUsufructuariesTooltipText';
import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';
import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

import InputNumber from 'modules/_shared/components/InputNumber';
import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';
import { DividendData } from '../types/DividendData';

type DividendsTableRowProps = {
  index: number;
  dividend: DividendData;
};

const DividendsTableRow: FC<DividendsTableRowProps> = ({ index, dividend }) => {
  const { data, actions } = useDividendsDistributionModal();

  const {
    data: { tooltipText },
  } = useGetUsufructuariesTooltipText({
    usufructData: dividend.usufructData,
  });

  const { partnerId, partnerName, ndPercent, dividendAmount, retentionAmount } =
    dividend;

  const existingIndex = data.customRetentions?.findIndex(
    (retention) => retention.partner === partnerId
  );

  const retentionPercentage =
    existingIndex !== -1 && existingIndex !== undefined
      ? data.customRetentions[existingIndex].retentionPercentage
      : data.retentionPercentage;

  const handleChangeRetentionPercentage = (value: number) => {
    actions.handleChangeCustomRetention(partnerId, value);
  };

  const cells = [
    {
      key: `partner-name-${index}`,
      content: (
        <div className="tb-tnx-info w-150px d-flex align-items-center">
          <span className="title">{partnerName}</span>
          {tooltipText && (
            <IconTooltip id={`usufruct-info-${index}`} tooltip={tooltipText} />
          )}
        </div>
      ),
    },

    {
      key: `ndPercent-${index}`,
      content: <span>{formatNumberDecimals(ndPercent)}%</span>,
      textPosition: 'right',
    },

    data.hasRetention
      ? {
          key: `retentionPercent-${index}`,
          content: (
            <InputNumber
              id={`retention-percent-${index}`}
              value={retentionPercentage}
              decimalScale={2}
              max={100}
              formGroupClassName="w-90px justify-self-end"
              onChange={handleChangeRetentionPercentage}
              lgSize={false}
              iconRight="ni ni-percent"
            />
          ),

          textPosition: 'right',
          className: 'p-0',
        }
      : null,

    data.hasRetention
      ? {
          key: `dividendAmount-${index}`,
          content: formatCurrencyDecimals(dividendAmount),
          textPosition: 'right',
        }
      : null,

    {
      key: `toPerceive-${index}`,
      content: formatCurrencyDecimals(dividendAmount - retentionAmount),
      textPosition: 'right',
    },
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default DividendsTableRow;
